import Container from '@material-ui/core/Container'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import ContainerMaxWidthXl from 'components/Surfaces/ContainerMaxWidthXl'
import React, { forwardRef } from 'react'

const useStyles = makeStyles({
    contentContainer: {
        bottom: 0,
        left: 0,
        right: 0,
        overflow: 'auto',
    },
})

export interface ContentContainerProps {
    /** Top position on the screen. */
    top?: number
    position?: 'absolute' | 'relative'
    height?: string | number
    disableGutters?: boolean
    className?: string
}

/**
 *   Container to house app-specific contents.
 */
const ContentContainer = forwardRef<
    HTMLDivElement,
    React.PropsWithChildren<ContentContainerProps>
>(
    (
        {
            top = 100,
            position = 'absolute',
            height = 'unset',
            disableGutters = false,
            children,
            className,
        },
        ref
    ) => {
        const classes = useStyles()
        return (
            <Container
                maxWidth={false}
                style={{
                    position: position,
                    top: top,
                    height: height,
                }}
                className={clsx(classes.contentContainer, className)}
                innerRef={ref}
                disableGutters={disableGutters}
            >
                <ContainerMaxWidthXl>{children}</ContainerMaxWidthXl>
            </Container>
        )
    }
)

export default ContentContainer
